import { forwardRef, type Ref, type SVGProps } from "react";
const IconConcealOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27.8 6.4a1 1 0 0 0-1.4-.2l-2.7 2.2A14 14 0 0 0 16.1 6C9.7 6 4.7 11 2.5 13.7a2 2 0 0 0 0 2.6 26.8 26.8 0 0 0 5.4 5l-3.5 2.9a1 1 0 0 0-.2 1.4 1 1 0 0 0 .8.4 1 1 0 0 0 .6-.2l4.1-3.4 2.7-2.2 2.8-2.3 3.8-3 2.6-2.1 3.8-3.1 2.2-1.9a1 1 0 0 0 .2-1.4M8 15a8 8 0 0 0 1.7 4.9l-.2.1A24.4 24.4 0 0 1 4 15a23.9 23.9 0 0 1 5.9-5.1A8 8 0 0 0 8 15m8.3-.6a1.4 1.4 0 0 1-.3-.9 1.5 1.5 0 0 1 .9-1.4 3 3 0 0 0-.9-.1 3 3 0 0 0-2.4 4.7l-2.4 2A5.9 5.9 0 0 1 10 15a6 6 0 0 1 10.5-4zm13.2-.7a34 34 0 0 0-2.6-2.8L22 15a6 6 0 0 1-6 6 5.6 5.6 0 0 1-1.2-.1l-3 2.4a12.7 12.7 0 0 0 4 .7c6.5 0 11.5-5 13.7-7.7a2 2 0 0 0 0-2.6m-7.4 6.4A8 8 0 0 0 24 16l2.9-2.3L28 15a24 24 0 0 1-5.9 5.1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconConcealOutlineSVG);
ForwardRef.displayName = "IconConcealOutline";
export { ForwardRef as IconConcealOutline };
